import { Link } from "react-router-dom";
import "./marca.css";

/** Icone oficial: casa branca dentro do circulo azul da marca. */
export function Icone({ tamanho = 28 }: { tamanho?: number }) {
  return (
    <svg className="marca__icone" width={tamanho} height={tamanho}
      viewBox="0 0 35 35" fill="none" aria-hidden="true">
      <rect width="34.707" height="34.707" rx="17.3535" fill="#275BF6" />
      <path
        d="M25.2754 22.484V14.992C25.2754 14.6741 25.1269 14.3745 24.8739 14.182L18.0157 8.96479C17.6541 8.68968 17.1539 8.68764 16.79 8.9598L9.80772 14.1822C9.55083 14.3744 9.39958 14.6764 9.39958 14.9972V22.484C9.39958 23.0461 9.85521 23.5017 10.4173 23.5017H14.2344C14.7965 23.5017 15.2521 23.0461 15.2521 22.484V19.4069C15.2521 18.8448 15.7077 18.3892 16.2698 18.3892H18.4052C18.9672 18.3892 19.4229 18.8448 19.4229 19.4069V22.484C19.4229 23.0461 19.8785 23.5017 20.4406 23.5017H24.2577C24.8198 23.5017 25.2754 23.0461 25.2754 22.484Z"
        stroke="#fff" strokeWidth="2.42173" strokeLinejoin="round"
      />
    </svg>
  );
}

export function MarcaTexto({
  altura = 30,
  invertida = false,
}: {
  altura?: number;
  invertida?: boolean;
}) {
  const largura = Math.round((138 / 44) * altura);
  return (
    <img
      className={`marca-texto${invertida ? " marca-texto--invertida" : ""}`}
      src="/logotipo.svg"
      width={largura}
      height={altura}
      alt="alugando.com"
    />
  );
}

export function Marca({ para = "/", reloadDocument = false }: { para?: string; reloadDocument?: boolean }) {
  return (
    <Link to={para} reloadDocument={reloadDocument} className="marca-completa">
      <Icone />
      <MarcaTexto />
    </Link>
  );
}

export function CabecalhoPublico({ acao, reloadDocument = false }: { acao?: React.ReactNode; reloadDocument?: boolean }) {
  return (
    <header className="cabecalho-publico">
      <div className="cabecalho-publico__interno">
        <Marca reloadDocument={reloadDocument} />
        {acao}
      </div>
    </header>
  );
}
